/* One behaviour for every moving backdrop.

   The markup lays a <video> over the same photograph that was there before.
   What is decided here is whether to show it at all, and whether it plays while
   nobody is looking at it.

   Four reasons not to show it: someone asked their system for less motion; the
   browser reported a connection that counts data; autoplay was refused, which is
   what a phone does in low power mode; the file would not decode. In every case
   the photograph remains, and that is an ordinary page rather than a broken one.

   While a band is off screen its video is paused: the decoder should not be
   turning four clips on a page where one is visible. */
(function () {
  var VIDEOS = 'video.sa-backdrop';

  function stillWanted() {
    try {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    } catch (e) {}
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (c) {
      if (c.saveData) return false;
      if (/(^|-)2g$/.test(c.effectiveType || '')) return false;
    }
    return true;
  }

  /* A narrow screen keeps the photograph on a band, and not only to save data.
     The bands are cropped to portrait on a phone, often from a different file
     altogether, while the clip was shot landscape: at 390 points all that would
     survive is its middle, with the composition gone. A tile is square on every
     screen, so a tile's clip says so and is let through. */
  function narrow() {
    try { return window.matchMedia('(max-width: 749px)').matches; } catch (e) { return false; }
  }
  function wantedHere(v) {
    return !narrow() || v.hasAttribute('data-sa-backdrop-phone');
  }

  function ready(v) {
    v.setAttribute('data-sa-backdrop-ready', '');
  }

  function start(v) {
    if (v.dataset.saBackdropStarted) return;
    v.dataset.saBackdropStarted = '1';

    /* The markup arrives with no autoplay and with preload="none", so up to
       this line the clip has cost nothing at all. Here and only here is it
       decided that it is wanted: allow the download first, then ask it to
       play. */
    v.preload = 'auto';
    if (typeof v.load === 'function') v.load();

    /* Faded in on any sign that frames have started, not on one event. On
       canplay alone a clip below the first screen went on playing at zero
       opacity: the event had already passed before anything was listening for
       it, and a second one is never coming. */
    function settle() { if (v.readyState >= 2) ready(v); }
    settle();
    ['loadeddata', 'canplay', 'playing', 'timeupdate'].forEach(function (ev) {
      v.addEventListener(ev, settle);
    });

    v.addEventListener('error', function () { v.remove(); }, { once: true });

    var p = v.play();
    if (p && typeof p.then === 'function') {
      p.then(settle, function () {
        // Autoplay was refused. The photograph under it is already in place.
        v.remove();
      });
    }
  }

  function watch(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var vids = Array.prototype.slice.call(scope.querySelectorAll(VIDEOS)).filter(function (v) {
      /* a clip already on the list is not put on it twice */
      if (v.dataset.saBackdropWatched) return false;
      v.dataset.saBackdropWatched = '1';
      return true;
    });
    if (!vids.length) return;

    if (!stillWanted()) {
      vids.forEach(function (v) { v.remove(); });
      return;
    }
    vids = vids.filter(function (v) {
      if (wantedHere(v)) return true;
      v.remove();
      return false;
    });
    if (!vids.length) return;

    if (!('IntersectionObserver' in window)) {
      vids.forEach(start);
      return;
    }

    /* A dwell gate, the way the reference store guards its own clips: a tile
       has to stay near the screen for a moment before its clip is asked for,
       so flicking down a page of seventeen tiles loads nothing at all, and
       a phone's media process is not asked to open seventeen decoders at
       once. A clip that has left the screen is paused, not thrown away, so
       scrolling back up does not fetch it twice. */
    var DWELL = 250;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.dataset.saBackdropStarted) {
            if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function(){}); }
            return;
          }
          if (v._saDwell) return;
          v._saDwell = setTimeout(function () { v._saDwell = null; start(v); }, DWELL);
        } else {
          if (v._saDwell) { clearTimeout(v._saDwell); v._saDwell = null; }
          if (!v.paused) v.pause();
        }
      });
    }, { rootMargin: '200px 0px' });

    vids.forEach(function (v) { io.observe(v); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { watch(); }, { once: true });
  } else {
    watch();
  }

  /* markup added after the page was read, like the copies a drifting shelf
     makes of its own tiles, asks for its clips through this */
  window.saBackdropWatch = watch;

  // A section redrawn by the theme editor has to come to life as well.
  document.addEventListener('shopify:section:load', function () { watch(); });
})();
